/**
 * 活动页面
 */
import { request } from '@/assets/js/request.js'
let fixUrl = 'app20/order-service/order20/'
let activityUrl = 'app20/activity-service/activity20/'
let couponUrl = 'app20/promotion-service/promotion20/'
let userUrl = 'app20/user-base-service/user20/'
// 房车语录征集
const saveFormData = (data) => {
  return request({
    method: 'post',
    url: `${fixUrl}api/activity/form/save`,
    data: {
      d: data
    },
  })
}
const getImageCode = (data) => {
  return request({
    method: 'get',
    url: `${fixUrl}api/activity/getImageCode`,
    data,
  })
}


// 小程序联合登陆
const loginBySign = (sign) => {
  return request({
    method: 'get',
    url: `union/login?sign=${sign}`,
    data: {},
  })
}
// 投票初始化
const voteInit = (id) => {
  return request({
    method: 'post',
    url: `${activityUrl}api/voteActivity/detail/${id}`,
    headers: {
      'usertoken': localStorage.userToken,
    },
    data: {
      d: {}
    },
  })
}
// 投票
const voteSubmit = (data) => {
  return request({
    method: 'post',
    url: `${activityUrl}api/voteActivity/vote`,
    data: {
      d: data
    },
  })
}
// 奖励
const getReward = (data) => {
  return request({
    method: 'post',
    url: `${activityUrl}api/userAccount/queryPageDetailListApi`,
    data: {
      d: JSON.stringify(data)
    },
  })
}

// 老带新接口
const oldwithnewDesc = (data) => {
  return request({
    method: 'post',
    url: `${activityUrl}api/activity/detailAdditionalInfo`,
    data: {
      d: JSON.stringify(data)
    },
  })
}
const oldwithnewAccM = () => {
  return request({
    method: 'post',
    url: `${activityUrl}api/userAccount/getUserActivityAccount`,
    data: {},
  })
}
const oldwithnewGetCash1 = (data) => {
  return request({
    method: 'post',
    url: `${activityUrl}api/withdraw/step1`,
    data: {
      d: JSON.stringify(data)
    },
  })
}
const oldwithnewGetCash2 = (data) => {
  return request({
    method: 'post',
    url: `${activityUrl}api/withdraw/step2`,
    data: {
      d: JSON.stringify(data)
    },
  })
}
const oldwithnewGetCoupon = (data) => {
  return request({
    method: 'post',
    url: `${activityUrl}api/activity/receiveCoupon`,
    data: {
      d: JSON.stringify(data)
    },
  })
}
const oldwithnewSahre = (data) => {
  return request({
    method: 'post',
    url: `${activityUrl}api/activity/share`,
    data: {
      d: JSON.stringify(data)
    },
  })
}
const oldwithnewQueryBtn = (data) => {
  return request({
    method: 'post',
    url: `${activityUrl}/api/activity/queryBtn`,
    data: {
      d: JSON.stringify(data)
    },
  })
}
const oldwithnewPublic = (data) => {
  return request({
    method: 'post',
    url: `${activityUrl}api/activity/queryMsg`,
    data: {
      d: JSON.stringify(data)
    },
  })
}
const share = () => {
  return request({
    method: 'get',
    url: `union/getSign`,
    data: {
      d: JSON.stringify()
    },
  })
}

// 活动详情
const getFilmInfo = (activityId) => {
  return request({
    method: 'get',
    url: `${activityUrl}api/contributeActivity/getDetailById/${activityId}`,
    data: {},
  })
}

// 提交活动
const submitFilmInfo = (data) => {
  return request({
    method: 'post',
    url: `${activityUrl}api/contributeActivity/commit`,
    data: {
      d: JSON.stringify(data)
    },
  })
}
// 提交活动
const couponItem = (data) => {
  return request({
    method: 'post',
    url: `${couponUrl}api/coupon/cms/getList`,
    data: {
      d: JSON.stringify(data)
    },
  })
}
// 24好玩活动
const get24Url = (data) => {
  return request({
    method: 'post',
    url: `${userUrl}api/haowan/getUrl`,
    data: {
      d: JSON.stringify(data)
    },
  })
}

// 打开小程序
const openMiniByUrl = (data) => {
  return request({
    method: 'post',
    url: `${activityUrl}api/wx/get/urllink`,
    data: {
      d: JSON.stringify(data)
    },
  })
}

// sem活动详情
const getSemDetail = (activityId) => {
  return request({
    method: 'get',
    url: `${activityUrl}api/activity/semDetail/${activityId}`,
    data: {},
  })
}

// sem领券
const joinSemActivity = (data) => {
  return request({
    method: 'post',
    url: `${activityUrl}api/activity/semActivity`,
    data: {
      d: JSON.stringify(data)
    },
  })
}
// 抽奖活动
const getLotteryBaseInfo = (activityId) => {
  return request({
    method: 'get',
    url: `${activityUrl}api/lottery/portalPage/${activityId}`,
    data: {}
  })
}
// 抽奖活动-开始抽奖
const startLottery = (data) => {
  return request({
    method: 'post',
    url: `${activityUrl}api/lottery/once`,
    data: {
      d: JSON.stringify(data)
    },
  })
}
// 抽奖活动-邀请好友
const makeQrCode = (activityId) => {
  return request({
    method: 'get',
    url: `${activityUrl}api/lottery/inviteHelp/${activityId}`,
    data: {}
  })
}
// 判断是否存在微信好友关系
const queryFollowInfoExist = () => {
  return request({
    method: 'get',
    url: `${activityUrl}/api/qywx/sendCoupon/queryFollowInfoExist`,
  })
}
// 跳转前统计
const participate = (data) => {
  return request({
    method: 'post',
    url: `${activityUrl}api/lottery/participate`,
    data: {
      d: JSON.stringify(data)
    },
  })
}
// 缓存数据
const setShareCacheData = (data) => {
  return request({
    method: 'post',
    url: `${activityUrl}api/cach/putCachData`,
    data: {
      d: JSON.stringify(data)
    },
  })
}
export {
  saveFormData,
  getImageCode,
  loginBySign,
  voteInit,
  voteSubmit,
  getReward,
  oldwithnewDesc,
  oldwithnewAccM,
  oldwithnewGetCash1,
  oldwithnewGetCash2,
  oldwithnewGetCoupon,
  oldwithnewQueryBtn,
  oldwithnewSahre,
  oldwithnewPublic,
  share,
  getFilmInfo,
  submitFilmInfo,
  couponItem,
  get24Url,
  openMiniByUrl,
  getSemDetail,
  joinSemActivity,
  getLotteryBaseInfo,
  startLottery,
  makeQrCode,
  queryFollowInfoExist,
  participate,
  setShareCacheData
}



// WEBPACK FOOTER //
// ./src/api/activity.js